import {createApp} from 'vue'
import PostHeaderAddComment from './PostHeaderAddComment'

const el = '.kb-component--post-header-add-comment'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((PostHeaderAddCommentDOM) => {
            const props = {
                postId: PostHeaderAddCommentDOM.dataset.postId
            }
            
            const component = createApp(PostHeaderAddComment, props).use(Store)
            component.mount(PostHeaderAddCommentDOM)
        })
    }
}

